import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=796bb4ea"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports